import { render, staticRenderFns } from "./InvestigationDoctorReferralReport.vue?vue&type=template&id=ef7eba7c&scoped=true"
import script from "./InvestigationDoctorReferralReport.vue?vue&type=script&lang=js"
export * from "./InvestigationDoctorReferralReport.vue?vue&type=script&lang=js"
import style0 from "./InvestigationDoctorReferralReport.vue?vue&type=style&index=0&id=ef7eba7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7eba7c",
  null
  
)

export default component.exports